// @react/hooks/useBillingTransaction.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { billingTransactionStore } from '@core/stores';

/**
 * React hook for Transaction operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useBillingTransaction } from '@react/hooks';
 *
 * const TransactionList = observer(() => {
 *   const store = useBillingTransaction();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useBillingTransaction() {
  return billingTransactionStore;
}
